(() => {
  const init = () => {
    $('.exchange-coupon-active-frame').hide();
    $('.exchange-coupon-disabled-button').prop('disabled', true);
    $('body').on('click', '.selected-coupon-js', showActiveButton);
  }

  const showActiveButton = e => {
    const $element = $(e.currentTarget);
    $element.parents('.mypageCouponListOption').find('.exchange-coupon-disabled-frame').hide();
    $element.parents('.mypageCouponListOption').find('.exchange-coupon-active-frame').show();
  }
  $(init);
})();

